module.exports = __webpack_public_path__ + "img/people_bz.7a5fbe19.png";